/*
 * Copyright (c) Nexign, JSC, 2021-2023.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Ilya Babanov
 * @version 1.23.0
 * @since 1.14.0
 */

import type { IInputSearchItem } from '@components/common/InputSearch/types';
import { EAddressElement } from '@pages/PageAccountInfo/types/pageAccountInfoGeneralTypes';

export enum EFormAddressType {
  account = 'account',
  subscriber = 'subscriber',
}

export enum EFormAddressField {
  apartment = 'apartment',
  apartmentOptional = 'apartmentOptional',
  block = 'block',
  city = 'city',
  house = 'house',
  houseOptional = 'houseOptional',
  planningElement = 'planningElement',
  planningElementOptional = 'planningElementOptional',
  street = 'street',
  streetOptional = 'streetOptional',
  structure = 'structure',
}

interface IAttributeType {
  id: number;
  name: string;
}

interface IAirZip {
  addressId: number;
  addressString: string;
  attributes: Record<string, string>;
  postcode: string;
}
export interface IAttributes {
  block?: string;
  houseType?: IAttributeType;
  name?: string;
  number?: string;
  structure?: string;
  structureType?: IAttributeType;
  zip?: IAirZip;
}

export interface IFormAddressField {
  id?: string;
  def: string;
  type?: EAddressElement | null;
  attributes?: IAttributes;
}

export interface IFormAddressConfiguration {
  airId: string;
  addressId: string;
  addressString: string;
  [EFormAddressField.apartment]?: IFormAddressField | null;
  [EFormAddressField.apartmentOptional]?: boolean;
  [EFormAddressField.block]?: IFormAddressField | null;
  [EFormAddressField.city]?: IFormAddressField | null;
  [EFormAddressField.house]?: IFormAddressField | null;
  [EFormAddressField.houseOptional]?: boolean;
  [EFormAddressField.planningElement]?: IFormAddressField | null;
  [EFormAddressField.planningElementOptional]?: boolean;
  [EFormAddressField.street]?: IFormAddressField | null;
  [EFormAddressField.streetOptional]?: boolean;
  [EFormAddressField.structure]?: IFormAddressField | null;
}

export type TFormAddressSearchFoundItems = {
  [key in EFormAddressField]?: IInputSearchItem[];
};
export type TFormAddressSearchIsLoading = {
  [key in EFormAddressField]?: boolean;
};

export type TAddressElementId = number & { readonly brand: unique symbol };
export function AddressElementId(id: number) {
  return id as TAddressElementId;
}

interface IAddressElement {
  def: string;
  id: number;
  type?: EAddressElement | null;
  attributes: IAttributes | null;
}

export interface IFormAddressSearchResponse {
  addressElements?: IAddressElement[];
}
